<script>
export default {
  name: 'LegacySubHeader',
  props: {
    title: { type: String, default: '' },
    subText: { type: String, default: '' },
  },
}
</script>

<template>
  <section class="mb-4">
    <div class="flex items-baseline justify-between mb-3">
      <div>
        <h2 class="text-lg font-semibold text-foreground">{{ title }}</h2>
        <p v-if="subText" class="text-sm text-muted-foreground">{{ subText }}</p>
      </div>
      <div>
        <slot name="buttons" />
      </div>
    </div>
    <div
      v-if="$slots.stats"
      class="grid grid-cols-2 md:grid-cols-4 gap-3"
    >
      <slot name="stats" />
    </div>
    <slot />
  </section>
</template>
